import BaseService from './BaseService'

class PhoneService extends BaseService {

  constructor () {
    super({path: 'phones'})
  }

  async addPhone ({ entity, entityId, data }) {
    try {
      let res = await this.instance.post(`${entity}/${entityId}/phones`, data)
      return res.data
    } catch (e) {
      this._handleError({translationKey: 'address.add.error', error: e})
      throw e
    }
  }

  async updatePhone ({ entity, entityId, data }) {
    try {
      let res = await this.instance.put(`${entity}/${entityId}/phone/${data.id}`, data)
      return res.data
    } catch (e) {
      this._handleError({translationKey: 'phone.update.error', error: e})
      throw e
    }
  }

  async deletePhone ({ entity, entityId, id }) {
    try {
      let res = await this.instance.delete(`${entity}/${entityId}/phone/${id}`)
      return res.data
    } catch (e) {
      this._handleError({translationKey: 'phone.delete.error', error: e})
      throw e
    }
  }

  async setPrimary ({ entity, entityId, id }) {
    try {
      let res = await this.instance.post(`${entity}/${entityId}/phone/${id}/primary`, {})
      return res.data
    } catch (e) {
      this._handleError({translationKey: 'phone.set.primary.error', error: e})
      throw e
    }
  }

  async setFinancial ({ entity, entityId, id }) {
    try {
      let res = await this.instance.post(`${entity}/${entityId}/phone/${id}/financial`, {})
      return res.data
    } catch (e) {
      this._handleError({translationKey: 'phone.set.financial.error', error: e})
      throw e
    }
  }

  async setDelivery ({ entity, entityId, id }) {
    try {
      let res = await this.instance.post(`${entity}/${entityId}/phone/${id}/delivery`, {})
      return res.data
    } catch (e) {
      this._handleError({translationKey: 'phone.set.delivery.error', error: e})
      throw e
    }
  }

}

export default new PhoneService()
